/**
 * String utility functions for safe handling of potentially undefined values
 * and consistent type handling throughout the application.
 */

/**
 * Ensures a value is a valid string or returns an empty string
 * @param value Any value that needs to be safely converted to a string
 * @returns The value as a string or empty string if invalid
 */
export const safeString = (value: unknown): string => {
  return (typeof value === 'string') ? value : '';
};

/**
 * Checks if a string exists, is a string type, and has content
 * @param str The string value to validate
 * @returns Boolean indicating if the string is valid and non-empty
 */
export const hasValidString = (str?: string | unknown): boolean => {
  return !!str && typeof str === 'string' && str.trim().length > 0;
}; 